import ReactECharts from 'echarts-for-react'
import { ScoopTheme } from './Style'
import * as React from 'react'
import { ServerSideGrid } from './InsightsGrid/ServerSideGrid'
import _ from 'lodash'
import styles from './Insight.module.scss'
import { ScoopMenu, ScoopMenuItem, ScoopSpinner, ScoopButton, ScoopText } from '../ui'
import { XIcon, CaretRightIcon } from '@phosphor-icons/react'
import { KPI } from './KPI/KPI'
import { buildInsightOption } from '../../shared/charts/insightOption'
import { ArrowSquareLeftIcon, ArrowSquareRightIcon } from '@phosphor-icons/react'

export function Insight({
    chartProperties,
    config,
    setConfig,
    embeddedSizeProps,
    server,
    clickable,
    advanced,
    analyzeChanges,
    handleCreateFilter,
    setColumnLoading,
    workspaceMetadata,
    activePrompts,
    dateFlag,
    theme,
    setDataTabOpen,
    dataTabOpen,
    setConfigTabOpen,
    configTabOpen,
    chat,
    slack,
}) {
    const [style, setStyle] = React.useState({})
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [seriesName, setSeriesName] = React.useState(null)
    const [drillColumn, setDrillColumn] = React.useState(null)
    const [drillingHistory, setDrillingHistory] = React.useState([])
    const [categoryValue, setCategoryValue] = React.useState(null)
    const openMenu = Boolean(anchorEl)

    const handleMenuClick = (event) => {
        setAnchorEl(event.event.event.currentTarget)
        if (config.view === 'chart') {
            setStyle({
                position: 'absolute',
                left: event.event.event.clientX + 'px',
                top: event.event.event.clientY + 'px',
                minHeight: 300 + 'px',
            })
        } else {
            setDrillColumn(event.drillColumn)
        }
        if (event.name) setCategoryValue(event.name)
        setSeriesName(event.seriesName)
    }

    const handleTableMenuClose = (event, col) => {
        setAnchorEl(null)
        if (event.key === 'Escape' || event.currentTarget.textContent === '') return
        let newFilter = {
            attributeName: drillColumn.columnName,
            operator: 'Equals',
            filterValue: {
                values: [seriesName],
            },
        }
        let curFilter = chartProperties.addFilterItem(newFilter)
        config.selectedTableColumns.push(col)
        config.filter = curFilter
        if (drillingHistory.length === 0) {
            setDrillingHistory([
                { attribute: drillColumn.columnName },
                {
                    attribute: event.currentTarget.textContent,
                    filter: newFilter,
                },
            ])
        } else {
            setDrillingHistory([
                ...drillingHistory,
                {
                    attribute: event.currentTarget.textContent,
                    filter: newFilter,
                },
            ])
        }
        setConfig({ ...config })
    }

    const handleChartMenuClose = (event) => {
        setAnchorEl(null)
        if (event.key === 'Escape' || event.currentTarget.textContent === '') return
        if (chartProperties.config.drillAttribute) {
            chartProperties.config.usedDrillAttributes.push(chartProperties.config.drillAttribute)
            let series = chartProperties.getSeries(seriesName)
            if (series) {
                let newFilter = {
                    attributeName: config.drillAttribute,
                    operator: 'Equals',
                    filterValue: {
                        values: [series.category],
                    },
                }
                let curFilter = chartProperties.addFilterItem(newFilter)
                setDrillingHistory([
                    ...drillingHistory,
                    {
                        attribute: event.currentTarget.textContent,
                        filter: newFilter,
                        drillAttribute: drillingHistory.length === 0 ? config.drillAttribute : null,
                    },
                ])
                config.drillAttribute = event.currentTarget.textContent
                config.filter = curFilter
                chartProperties.getResults(config, null, activePrompts)
            }
        } else {
            config.drillAttribute = event.currentTarget.textContent
            const category = config.categoryAxis
            if (categoryValue && category && category !== 'Time') {
                let newFilter = {
                    attributeName: category,
                    operator: 'Equals',
                    filterValue: { values: [categoryValue] },
                }
                config.filter = chartProperties.addFilterItem(newFilter)
                setDrillingHistory([
                    ...drillingHistory,
                    {
                        attribute: event.currentTarget.textContent,
                        filter: newFilter,
                    },
                ])
                chartProperties.getResults(config, null, activePrompts)
            } else {
                setDrillingHistory([
                    ...drillingHistory,
                    { attribute: event.currentTarget.textContent },
                ])
                chartProperties.getResults(config, null, activePrompts)
            }
        }
        setConfig({ ...config })
    }

    function onChartClick(event) {
        handleMenuClick(event)
    }

    const onEvents = {
        click:
            !chat && config.seriesType !== 'pie' && config.seriesType !== 'donut'
                ? onChartClick
                : null,
    }

    function validChart() {
        if (config.view === 'kpi') return config.selectedItems.length > 0
        if (
            config.view === 'table' &&
            (config.selectedTableColumns.length > 0 || config.selectedTableKpis.length > 0)
        )
            return true
        // if (
        //     chartProperties.config.seriesType === 'scatter' &&
        //     chartProperties.config.selectedItems &&
        //     chartProperties.config.selectedItems?.length !== 2
        // )
        //     return false
        return (
            chartProperties.series &&
            chartProperties.series?.length > 0 &&
            ((chartProperties.result.dates && chartProperties.result.dates?.length > 0) ||
                chartProperties.series[0].data?.length > 0)
        )
    }

    const chartSetting = {
        height: embeddedSizeProps
            ? embeddedSizeProps.height
            : chat
              ? config.view === 'kpi'
                  ? 250
                  : 400
              : window.innerHeight - 112 - 64 + 'px',
        pointerEvents: clickable ? 'all' : 'none',
        margin: embeddedSizeProps || chat ? 0 : '32px',
    }

    const getChartDrillItems = () => {
        let drillAtts = []
        if (chartProperties.drillAttributes?.length > 0) {
            drillAtts = chartProperties.drillAttributes?.map((item) => {
                if (
                    item === chartProperties.categoryAxis ||
                    item === chartProperties.config.drillAttribute ||
                    item === chartProperties.config.categoryAxis ||
                    !chartProperties.getAvailableDrillAttributes().includes(item) ||
                    chartProperties.config.selectedTableColumns.includes(item)
                ) {
                    return null
                }
                return (
                    <ScoopMenuItem key={item} onClick={handleChartMenuClose}>
                        {item}
                    </ScoopMenuItem>
                )
            })
        }
        let changeDrillAtts = []
        if (advanced && analyzeChanges && chartProperties.changeDrillAttributes?.length > 0) {
            changeDrillAtts =
                advanced &&
                analyzeChanges &&
                chartProperties.changeDrillAttributes.map((item) => {
                    if (
                        item === chartProperties.categoryAxis ||
                        item === chartProperties.config.drillAttribute
                    ) {
                        return null
                    }
                    return (
                        <ScoopMenuItem key={item} onClick={handleChartMenuClose}>
                            {item}
                        </ScoopMenuItem>
                    )
                })
        }
        return [...drillAtts, ...changeDrillAtts]
    }

    const getTableDrillItems = () => {
        const tables = []
        workspaceMetadata?.inboxes?.forEach((inbox) => {
            inbox.tables.forEach((table) => {
                if (config.selectedTables.includes(table.reportSeriesTableID)) tables.push(table)
            })
        })
        const columns = _.intersection(
            ...tables.map((table) =>
                table.columns.map((col) => ({
                    ...col,
                    reportSeriesTableID: table.reportSeriesTableID,
                }))
            )
        )
        if (!columns) {
            let a = 1
        }
        const availableDrills = columns.filter((column) => {
            if (!column) {
                let a = 1
            }
            return (
                !column.isMeasure &&
                !config.selectedTableColumns.some((col) => col.columnName === column.columnName)
            )
        })
        return availableDrills.map((col) => (
            <ScoopMenuItem key={col.columnName} onClick={(e) => handleTableMenuClose(e, col)}>
                {col.columnName}
            </ScoopMenuItem>
        ))
    }

    const handleDeleteDrillingStep = (step, i) => {
        const newConfig = { ...config }
        const newDrillingHistory = [...drillingHistory]
        if (config.view === 'chart') {
            if (drillingHistory.length === 1) {
                newConfig.filter = chartProperties.removeFilterItem(step.filter)
                // empty drill attribute from config
                newConfig.drillAttribute = step.drillAttribute
                // empty drill history
                setDrillingHistory([])
            } else {
                // move drill attribute
                newConfig.drillAttribute = newDrillingHistory[i - 1].attribute
                // remove step filter
                newConfig.filter = chartProperties.removeFilterItem(step.filter)
                // remove step from history
                newDrillingHistory.splice(i, 1)
                // enable drill attribute again
                newConfig.usedDrillAttributes.splice(
                    newConfig.usedDrillAttributes.indexOf(step.attribute),
                    1
                )
                setDrillingHistory(newDrillingHistory)
            }
            setConfig(newConfig)
            chartProperties.getResults(newConfig, null, activePrompts)
        } else {
            // remove column
            const deleteIndex = newConfig.selectedTableColumns.findIndex(
                (col) => col.columnName === step.attribute
            )
            newConfig.selectedTableColumns.splice(deleteIndex, 1)
            // remove step filter
            newConfig.filter = chartProperties.removeFilterItem(step.filter)
            if (drillingHistory.length === 2) {
                // empty drill history
                setDrillingHistory([])
            } else {
                // remove step from history
                newDrillingHistory.splice(i, 1)
                setDrillingHistory(newDrillingHistory)
            }
            setConfig(newConfig)
        }
    }

    const navigateToStep = (step, i) => {
        const newConfig = { ...config }
        let newDrillingHistory = [...drillingHistory]
        const toDeleteSteps = newDrillingHistory.slice(i + 1)
        if (config.view === 'chart') {
            toDeleteSteps.forEach((s) => {
                // remove filters from steps > selected step
                newConfig.filter = chartProperties.removeFilterItem(s.filter)
                // enable drill attribute again
                newConfig.usedDrillAttributes.splice(
                    newConfig.usedDrillAttributes.indexOf(s.attribute),
                    1
                )
            })
            // move drill attribute to selected step
            newConfig.drillAttribute = step.attribute
            // remove left steps > selected step
            newDrillingHistory = newDrillingHistory.slice(0, i + 1)
            setDrillingHistory(newDrillingHistory)
            setConfig(newConfig)
            chartProperties.getResults(newConfig, null, activePrompts)
        } else {
            toDeleteSteps.forEach((s) => {
                // remove column
                const deleteIndex = newConfig.selectedTableColumns.findIndex(
                    (col) => col.columnName === s.attribute
                )
                newConfig.selectedTableColumns.splice(deleteIndex, 1)
                // remove step filter
                newConfig.filter = chartProperties.removeFilterItem(s.filter)
            })
            // remove left steps > selected step
            newDrillingHistory = newDrillingHistory.slice(0, i + 1)
            setDrillingHistory(newDrillingHistory)
            setConfig(newConfig)
        }
    }

    const isStepClickable = (i) => {
        if (config.view === 'chart') return i < drillingHistory.length - 1
        else return i > 0 && i < drillingHistory.length - 1
    }

    // Option building lives in the shared chart module (also used by the portal).
    const getOptionWithOverrides = () =>
        buildInsightOption({
            chartProperties,
            config,
            theme,
            workspaceMetadata,
            chat,
            slack,
            embeddedSizeProps,
        })

    const calculateChartContainerProps = () => {
        let width = window.innerWidth
        let left = 0
        let right = 0
        if (configTabOpen) {
            width -= 300
            right += 300
        }
        if (dataTabOpen) {
            width -= 300
            left += 300
        }
        return { width, left, right }
    }

    const renderInsight = () => {
        switch (config.view) {
            case 'table':
                return (
                    <ServerSideGrid
                        handleMenuClick={handleMenuClick}
                        config={config}
                        setConfig={setConfig}
                        embeddedSizeProps={embeddedSizeProps}
                        server={server}
                        clickable={clickable}
                        prompts={activePrompts}
                        handleCreateFilter={handleCreateFilter}
                        setColumnLoading={setColumnLoading}
                        dateFlag={dateFlag}
                        theme={theme}
                    />
                )
            case 'chart':
                return (
                    <ReactECharts
                        opts={slack ? { renderer: 'svg' } : undefined}
                        option={getOptionWithOverrides()}
                        notMerge={true}
                        lazyUpdate={true}
                        style={chartSetting}
                        theme={ScoopTheme}
                        onEvents={onEvents}
                    />
                )
            case 'kpi':
                return (
                    <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                        <KPI
                            config={config}
                            setConfig={setConfig}
                            server={server}
                            embeddedSizeProps={embeddedSizeProps}
                            theme={theme}
                            prompts={activePrompts}
                            chat={chat}
                        />
                    </div>
                )
        }
    }

    const renderNoData = () => {
        return (
            <div
                style={{
                    height: '100%',
                    width: '100%',
                    display: 'grid',
                    placeContent: 'center',
                    color: 'var(--scoop-color-text-primary)',
                }}
            >
                <ScoopText className={'inter'}>No data found for current configuration</ScoopText>
            </div>
        )
    }

    return (
        <>
            {chartProperties.config.loading || theme === '' ? (
                <div
                    style={{
                        height: '100%',
                        display: 'grid',
                        placeContent: 'center',
                    }}
                >
                    <ScoopSpinner size={56} />
                </div>
            ) : validChart() ? (
                <div
                    style={
                        !embeddedSizeProps && !chat
                            ? {
                                  position: 'absolute',
                                  width: calculateChartContainerProps().width,
                                  left: calculateChartContainerProps().left,
                                  right: calculateChartContainerProps().right,
                                  height: '100%',
                              }
                            : { height: '100%', width: '100%' }
                    }
                >
                    {drillingHistory.length > 0 && (
                        <div
                            className={styles.drillingBreadcrumbsContainer}
                            style={
                                !embeddedSizeProps
                                    ? {
                                          position: 'absolute',
                                          top: 10,
                                          left: 32,
                                      }
                                    : {}
                            }
                        >
                            {drillingHistory.map((step, i) => (
                                <div
                                    key={i + step.attribute}
                                    className={styles.drillStep}
                                    style={{
                                        color: theme?.colorScheme?.darkTheme ? 'white' : 'black',
                                    }}
                                >
                                    <span
                                        className={`inter ${isStepClickable(i) ? styles.clickableStep : ''}`}
                                        style={{ marginRight: '5px', fontSize: '12px' }}
                                        onClick={() =>
                                            isStepClickable(i) ? navigateToStep(step, i) : null
                                        }
                                    >
                                        {i < drillingHistory.length - 1
                                            ? step.attribute +
                                              ' = ' +
                                              drillingHistory[i + 1].filter.filterValue.values[0]
                                            : step.attribute}
                                    </span>
                                    {i + 1 === drillingHistory.length && (
                                        <button
                                            type="button"
                                            style={{
                                                padding: '4px',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleDeleteDrillingStep(step, i)}
                                        >
                                            <XIcon
                                                size={12}
                                                weight="regular"
                                                color={
                                                    theme?.colorScheme?.darkTheme
                                                        ? 'white'
                                                        : 'black'
                                                }
                                            />
                                        </button>
                                    )}
                                    {i < drillingHistory.length - 1 && (
                                        <CaretRightIcon
                                            size={12}
                                            weight="regular"
                                            color={
                                                theme?.colorScheme?.darkTheme ? 'white' : 'black'
                                            }
                                            style={{ marginRight: '5px' }}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                    {renderInsight()}
                    {!embeddedSizeProps && !chat && (
                        <>
                            <ScoopButton
                                variant="text"
                                size="xxs"
                                onClick={() => setDataTabOpen(!dataTabOpen)}
                                className={styles.drawerToggleButton}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    zIndex: 100,
                                    borderRadius: '0 0 5px 0',
                                }}
                                aria-label={dataTabOpen ? 'Close left panel' : 'Open left panel'}
                            >
                                <ArrowSquareLeftIcon
                                    size={18}
                                    weight="regular"
                                    className={`${styles.drawerToggleIcon} ${dataTabOpen ? '' : styles.drawerToggleIconRotated}`}
                                />
                            </ScoopButton>
                            <ScoopButton
                                variant="text"
                                size="xxs"
                                onClick={() => setConfigTabOpen(!configTabOpen)}
                                className={styles.drawerToggleButton}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    zIndex: 100,
                                    borderRadius: '0 0 0 5px',
                                }}
                                aria-label={
                                    configTabOpen ? 'Close right panel' : 'Open right panel'
                                }
                            >
                                <ArrowSquareRightIcon
                                    size={18}
                                    weight="regular"
                                    className={`${styles.drawerToggleIcon} ${configTabOpen ? '' : styles.drawerToggleIconRotated}`}
                                />
                            </ScoopButton>
                        </>
                    )}
                </div>
            ) : (
                renderNoData()
            )}
            <ScoopMenu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleChartMenuClose}
                style={style}
            >
                {config.view === 'table' ? getTableDrillItems() : getChartDrillItems()}
            </ScoopMenu>
        </>
    )
}
